import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'app-legal-links-container',
  imports: [TranslocoDirective],
  templateUrl: './legal-links-container.component.html',
  styleUrl: './legal-links-container.component.css'
})
export class LegalLinksContainerComponent {
  public legalLinks = ConfigService.getLegalLinks();
}
